import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProductState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ProductState = {
  data: [],
  isLoading: false,
  error: null,
};

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setProductLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setProductError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setProducts, setProductLoading, setProductError } = productSlice.actions;

export default productSlice.reducer;
